import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "@/components/state/store";

interface Props {
  subdomain: string;
}

export default function DocumentTitle({ subdomain }: Props) {
  const { t } = useTranslation();
  const pageHeading = useSelector(
    (state: RootState) => state.pageHeading.heading
  );
  const portalTitle = t(
    subdomain === "admin"
      ? "kaer_staff_portal"
      : subdomain === "manage"
      ? "kaer_manager_portal"
      : "kaer_employee_portal"
  );

  useEffect(() => {
    document.title = pageHeading
      ? `${portalTitle} | ${pageHeading}`
      : portalTitle;
  }, [pageHeading, portalTitle]);

  return null;
}
